module.exports = __webpack_public_path__ + "static/media/camera.7197aa4c.svg";